module.exports = __webpack_public_path__ + "img/ywc.15eb489f.png";